import { styled } from '@mui/material/styles';
import { darken } from "@mui/material";

export const Container = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'inline-block',

  '.remove_button': {
    zIndex: 10,
    position: 'absolute',
    top: '0',
    right: '0',

    width: '24px',
    height: '24px',
    borderRadius: '50%',
    border: 'none',
    padding: 0,

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',

    backgroundColor: theme.palette.error.main,
    transition: 'background-color 0.2s linear',
    boxShadow: theme.shadows[2],

    '&:hover': {
      backgroundColor: darken(theme.palette.error.main, 0.2),
    },

    '> svg': {
      width: '16px',
      height: '16px',
      color: theme.palette.common.white,
    }
  }
}));
